import { Instant } from "@js-joda/core";
import { AuthTokens } from "./AuthTokens";

export type AuthSessionApiDto = {
  accessTokenExpiration: string;
  refreshTokenExpiration: string;
};

export type AuthSession = {
  accessTokenExpiration: Instant;
  refreshTokenExpiration: Instant;
};

export const toAuthSession = (dto: AuthSessionApiDto): AuthSession => ({
  accessTokenExpiration: Instant.parse(dto.accessTokenExpiration),
  refreshTokenExpiration: Instant.parse(dto.refreshTokenExpiration),
});

export const authTokensToAuthSession = (tokens: AuthTokens): AuthSession => ({
  accessTokenExpiration: Instant.parse(tokens.accessJwt.expiration),
  refreshTokenExpiration: Instant.parse(tokens.refreshJwt.expiration),
});

const accessTokenRefreshMarginInSeconds = 150;

export const isAccessTokenAboutToExpire = (session: AuthSession, now = Instant.now()) =>
  now.isAfter(session.accessTokenExpiration.minusSeconds(accessTokenRefreshMarginInSeconds));

export const isRefreshTokenExpired = (session: AuthSession, now = Instant.now()) =>
  now.isAfter(session.refreshTokenExpiration);
